/**
 * @generated SignedSource<<b96ce0d5fd9337cf16cb77dc6aae256c>>
 * @relayHash e4d3106ab141a2f59d322ffcf93f9edf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly color: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null | undefined;
      readonly contentStatus: string | null | undefined;
      readonly contentVersion: number | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly isActive: boolean | null | undefined;
      readonly lastModificationDate: {
        readonly value: string;
      } | null | undefined;
      readonly modifier: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly workflowId: string | null | undefined;
      readonly workflowStatusId: string | null | undefined;
    } | null | undefined;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly creatorAaid: string | null | undefined;
      readonly id: string;
      readonly reviewComment: string | null | undefined;
      readonly reviewLastModified: {
        readonly value: string;
      } | null | undefined;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null | undefined;
        readonly decisionId: string | null | undefined;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null | undefined;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null | undefined;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null | undefined;
        readonly reviewerId: string | null | undefined;
        readonly user: {
          readonly displayName: string | null | undefined;
          readonly id: string | null | undefined;
          readonly isActive: boolean | null | undefined;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null | undefined;
  } | null | undefined;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null | undefined;
      readonly version: {
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null | undefined;
      };
    };
  } | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    }
  ]
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "status"
},
v10 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v11 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v12 = {
  "args": [
    (v11/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v13 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v14 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v15 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v16 = [
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "success"
},
v18 = {
  "kind": "ScalarField",
  "name": "message"
},
v19 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v20 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v21 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/)
      ]
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v23 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v22/*: any*/)
  ]
},
v24 = [
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  (v14/*: any*/),
  (v15/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v26 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v27 = {
  "kind": "ScalarField",
  "name": "value"
},
v28 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v29 = [
  (v6/*: any*/),
  (v26/*: any*/),
  (v25/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v27/*: any*/),
      (v28/*: any*/)
    ]
  }
],
v30 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v29/*: any*/)
},
v31 = [
  (v27/*: any*/)
],
v32 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v25/*: any*/),
    (v30/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v31/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v29/*: any*/)
    }
  ]
},
v33 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v31/*: any*/)
    },
    (v22/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v31/*: any*/)
    },
    (v30/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        {
          "kind": "ScalarField",
          "name": "principalType"
        },
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v31/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v26/*: any*/),
            (v25/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v28/*: any*/),
                (v27/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v34 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v19/*: any*/),
        (v20/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ]
          }
        ]
      },
      (v12/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v16/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/)
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v21/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      (v12/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v16/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v34/*: any*/),
          (v23/*: any*/)
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v34/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e4d3106ab141a2f59d322ffcf93f9edf",
    "id": "9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "dc99427393f687e09e4c81762eb96704";

export default node;
